import { Avatar, InputAdornment, SxProps, Theme } from '@mui/material';
import { PurpleX } from 'Images';
import { KeyboardEvent, MouseEvent } from 'react';

interface ISearchFieldClearControlProps {
  ariaLabel: string;
  onClear: () => void;
  onMouseDown?: (event: MouseEvent) => void;
  onClick?: (event: MouseEvent) => void;
  size?: number | string;
  avatarSx?: SxProps<Theme>;
  iconSrc?: string;
}

const SearchFieldClearControl = ({
  ariaLabel,
  onClear,
  onMouseDown,
  onClick,
  size = '20px',
  avatarSx,
  iconSrc = PurpleX,
}: ISearchFieldClearControlProps) => (
  <Avatar
    src={iconSrc}
    alt=''
    role='button'
    aria-label={ariaLabel}
    tabIndex={0}
    onMouseDown={onMouseDown}
    onClick={(e) => {
      if (onClick) {
        onClick(e);
        return;
      }
      onClear();
    }}
    onKeyDown={(e: KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClear();
      }
    }}
    sx={{
      flexShrink: 0,
      width: size,
      height: size,
      cursor: 'pointer',
      '&:focus-visible': {
        outline: '3px solid #1525E8',
        outlineOffset: 2,
      },
      ...avatarSx,
    }}
  />
);

interface ISearchFieldClearEndAdornmentProps extends ISearchFieldClearControlProps {}

export const SearchFieldClearIconButton = SearchFieldClearControl;

export const SearchFieldClearEndAdornment = ({
  ariaLabel,
  onClear,
  onMouseDown,
  onClick,
  size = '20px',
  avatarSx,
  iconSrc,
}: ISearchFieldClearEndAdornmentProps) => (
  <InputAdornment position='end' sx={{ margin: 0, maxHeight: 'unset' }}>
    <SearchFieldClearControl
      ariaLabel={ariaLabel}
      onClear={onClear}
      onMouseDown={onMouseDown}
      onClick={onClick}
      size={size}
      avatarSx={avatarSx}
      iconSrc={iconSrc}
    />
  </InputAdornment>
);
